export const sensors = [
  {
    Sensor: 'AUV',
    rank: 2,
    category: 'platform',
    subcategory: '',
    sType: 'Device',
    Description: '',
    exData: '',
  },
  {
    Sensor: 'Drifter',
    rank: 2,
    category: 'platform',
    subcategory: '',
    sType: 'Device',
    Description:
      'A device that floats on the ocean surface, drifts with ocean currents, and is equipped with various sensors.',
    exData: 'https://simonscmap.com/catalog/datasets/Global_Drifter_Program',
  },
  {
    Sensor: 'Float',
    rank: 2,
    category: 'platform',
    subcategory: '',
    sType: 'Device',
    Description: '',
    exData: '',
  },
  {
    Sensor: 'Hyperpro',
    rank: 2,
    category: 'platform',
    subcategory: '',
    sType: 'Device',
    Description:
      'A device that is free-falling and deployed from a ship to measure apparent optical properties of the water column.',
    exData:
      'https://simonscmap.com/catalog/datasets/Gradients5_TN412_Hyperpro_Profiles, https://simonscmap.com/catalog/datasets/Gradients4_TN397_Hyperpro_UW',
  },
  {
    Sensor: 'Satellite',
    rank: 2,
    category: 'platform',
    subcategory: '',
    sType: 'Device',
    Description:
      'A platform that orbits Earth and is equipped with various sensors.',
    exData:
      'https://simonscmap.com/catalog/datasets/RCLV_atlas, https://simonscmap.com/catalog/datasets/SMAP_Ocean_Surface_Salinity_cl1',
  },
  {
    Sensor: 'Seaglider',
    rank: 2,
    category: 'platform',
    subcategory: '',
    sType: 'Device',
    Description: 'A free-swimming vehicle equipped with various sensors.',
    exData:
      'https://simonscmap.com/catalog/datasets/SG513M11D001_130, https://simonscmap.com/catalog/datasets/SG512M9D001_178',
  },
  {
    Sensor: 'Towfish',
    rank: 2,
    category: 'platform',
    subcategory: '',
    sType: 'Device',
    Description:
      'An underwater vehicle that is towed behind a vessel and equipped with various sensors.',
    exData:
      'https://simonscmap.com/catalog/datasets/Gradients_2_towfish_trace_metals',
  },
  {
    Sensor: '',
    rank: '',
    category: '',
    subcategory: '',
    sType: '',
    Description: '',
    exData: '',
  },
  {
    Sensor: 'CTD',
    rank: 3,
    category: 'CTD',
    subcategory: '',
    sType: 'Device',
    Description:
      'A device that measures conductivity, temperature, and depth.  This device is often equipped with additional sensors and deployed with a rosette (an array of niskin bottles) to sample water at various depths.',
    exData:
      'https://simonscmap.com/catalog/datasets/KOK1606_Gradients1_CTD, https://simonscmap.com/catalog/datasets/WW31_Paragon2_L1',
  },
  {
    Sensor: 'Trace Metal CTD',
    rank: 3,
    category: 'CTD',
    subcategory: '',
    sType: 'Device',
    Description: '',
    exData: '',
  },
  {
    Sensor: 'Underway CTD',
    rank: 3,
    category: 'CTD',
    subcategory: '',
    sType: 'Device',
    Description:
      'Measures conductivity, temperature, and depth from a vessel while it is underway.',
    exData:
      'https://simonscmap.com/catalog/datasets/KM1906_Gradients3_uwayCTD, https://simonscmap.com/catalog/datasets/PARAGON1_KM2112_underwayCTD',
  },
  {
    Sensor: '',
    rank: '',
    category: '',
    subcategory: '',
    sType: '',
    Description: '',
    exData: '',
  },
  {
    Sensor: 'Anemometer',
    rank: 4,
    category: 'equipment',
    subcategory: '',
    sType: 'Device',
    Description: 'Measures wind speed and pressure.',
    exData:
      'https://simonscmap.com/catalog/datasets/KM0704_CMORE_BULA_wind, https://simonscmap.com/catalog/datasets/JR19960422_AMT02_meteorology',
  },
  {
    Sensor: 'ATP photometer',
    rank: 4,
    category: 'equipment',
    subcategory: '',
    sType: 'Device',
    Description: 'Measures ATP concentration.',
    exData:
      'https://simonscmap.com/catalog/datasets/KM0704_CMORE_BULA_Bottle, https://simonscmap.com/catalog/datasets/km0704_cmore_bula_underway_samples',
  },
  {
    Sensor: 'Aquatic Laser Fluorescence Analyzer',
    rank: 4,
    category: 'equipment',
    subcategory: '',
    sType: 'Device',
    Description:
      'Measures laser stimulated emissions from phytoplankton pigments and chromophoric dissolved organic matter.',
    exData:
      'https://simonscmap.com/catalog/datasets/Tara_Oceans_Surface_Water_Measurements',
  },
  {
    Sensor: 'Automated Oxygen Titrator',
    rank: 4,
    category: 'equipment',
    subcategory: '',
    sType: 'Device',
    Description: 'Measures dissolved oxygen.',
    exData:
      'https://simonscmap.com/catalog/datasets/GO_SHIP_P16NS_2005_2006_515Y_926R',
  },
  {
    Sensor: 'Backscatter Sensor',
    rank: 4,
    category: 'equipment',
    subcategory: '',
    sType: 'Device',
    Description:
      'Measures optical backscattering. (See also Spectral Backscattering Sensor)',
    exData: 'https://simonscmap.com/catalog/datasets/ARGO_BGC',
  },
  {
    Sensor: 'Barometer',
    rank: 4,
    category: 'equipment',
    subcategory: '',
    sType: 'Device',
    Description: 'Measures atmospheric pressure.',
    exData:
      'https://simonscmap.com/catalog/datasets/JR19950921_amt01_meteorology, https://simonscmap.com/catalog/datasets/JR19960422_AMT02_meteorology',
  },
  {
    Sensor: 'Biospherical QSR 2150A',
    rank: 4,
    category: 'equipment',
    subcategory: '',
    sType: 'Device',
    Description: 'Measures Photosynthetically Active Radiation (PAR).',
    exData: 'https://simonscmap.com/catalog/datasets/TN397_Gradients4_uw_par',
  },
  {
    Sensor: 'Calorimeter',
    rank: 4,
    category: 'equipment',
    subcategory: '',
    sType: 'Device',
    Description: 'Measures the heat involved in a reaction.',
    exData:
      'https://simonscmap.com/catalog/datasets/HOT_LAVA, https://simonscmap.com/catalog/datasets/Falkor_2018',
  },
  {
    Sensor: 'Coulometer',
    rank: 4,
    category: 'equipment',
    subcategory: '',
    sType: 'Device',
    Description:
      'An instrument that uses an electrochemical method for quantitative analysis of various inorganic and organic compounds. In oceanography, often used for the determination of total dissolved inorganic carbon.',
    exData:
      'https://simonscmap.com/catalog/datasets/Karl_GR3_organic_and_inorganic_nutrients, https://simonscmap.com/catalog/datasets/KM0704_CMORE_BULA_Bottle',
  },
  {
    Sensor: 'Echosounder',
    rank: 4,
    category: 'equipment',
    subcategory: '',
    sType: 'Device',
    Description:
      'Measures the time it takes for a sound wave to reach an object and for the echo to return to calculate distance.',
    exData: '',
  },
  {
    Sensor: 'fluorometer',
    rank: 4,
    category: 'equipment',
    subcategory: '',
    sType: 'Device',
    Description: 'Measures fluorescence.',
    exData:
      'https://simonscmap.com/catalog/datasets/WW_Gradients5_Stn5_L1_v2, https://simonscmap.com/catalog/datasets/Gradients5_TN412_Optics_LISST_ACS_ECO',
  },
  {
    Sensor: 'High Throughput Sequencer',
    rank: 4,
    category: 'equipment',
    subcategory: '',
    sType: 'Device',
    Description:
      'Sequences DNA and RNA quickly and cost-effectively. (See also HiSeq 2500)',
    exData: '',
  },
  {
    Sensor: 'HiSeq 2500',
    rank: 4,
    category: 'equipment',
    subcategory: '',
    sType: 'Device',
    Description:
      'A high-throughput sequencing system produced by Illumina and designed for large-scale projects. (See also High Throughput Sequencer)',
    exData:
      'https://simonscmap.com/catalog/datasets/GO_SHIP_P16NS_2005_2006_515Y_926R',
  },
  {
    Sensor: 'Ion Sensitive Field Effect Transistor',
    rank: 4,
    category: 'equipment',
    subcategory: '',
    sType: 'Device',
    Description:
      'measures ion concentrations in solution, often used to measure pH.',
    exData: 'https://simonscmap.com/catalog/datasets/ARGO_BGC',
  },
  {
    Sensor: 'Liquid Scintillation Counter',
    rank: 4,
    category: 'equipment',
    subcategory: '',
    sType: 'Device',
    Description:
      'Used to quantify the radioactivity of beta and alpha-emitting isotopes.',
    exData:
      'https://simonscmap.com/catalog/datasets/PARAGON2_KM2209_Fe_Uptake_Timecourse, https://simonscmap.com/catalog/datasets/Gradients4_TN397_14C_NPP_DailyOnDeck',
  },
  {
    Sensor: 'Optode',
    rank: 4,
    category: 'equipment',
    subcategory: '',
    sType: 'Device',
    Description: 'An optical sensor typically used to measure oxygen.',
    exData:
      'https://simonscmap.com/catalog/datasets/sg626_4_qcpass, https://simonscmap.com/catalog/datasets/WW31_Paragon2_L1',
  },
  {
    Sensor: 'pH Sensor',
    rank: 4,
    category: 'equipment',
    subcategory: '',
    sType: 'Device',
    Description: 'Measures pH.',
    exData:
      'https://simonscmap.com/catalog/datasets/Tara_Oceans_Surface_Water_Measurements',
  },
  {
    Sensor: 'Potentiometric Electrode',
    rank: 4,
    category: 'equipment',
    subcategory: '',
    sType: 'Device',
    Description:
      'An electrode used in potentiometric titration, usually to find the concentration of a solute in a solution.',
    exData:
      'https://simonscmap.com/catalog/datasets/KM1709_mesoscope, https://simonscmap.com/catalog/datasets/HOT_LAVA',
  },
  {
    Sensor: 'Pyranometer',
    rank: 4,
    category: 'equipment',
    subcategory: '',
    sType: 'Device',
    Description: 'Measures solar radiation.',
    exData:
      'https://simonscmap.com/catalog/datasets/JR19950921_amt01_meteorology, https://simonscmap.com/catalog/datasets/JR19960422_AMT02_meteorology',
  },
  {
    Sensor: 'Radiometer',
    rank: 4,
    category: 'equipment',
    subcategory: '',
    sType: 'Device',
    Description: 'Measures electromagnetic radiation.',
    exData:
      'https://simonscmap.com/catalog/datasets/SUPERYACHT_2019_Rrs, https://simonscmap.com/catalog/datasets/HOELegacy2A_KM1513_LISST_Optics',
  },
  {
    Sensor: 'Salinometer',
    rank: 4,
    category: 'equipment',
    subcategory: '',
    sType: 'Device',
    Description: 'Measures salinity.',
    exData:
      'https://simonscmap.com/catalog/datasets/HOT_PP_v2022, https://simonscmap.com/catalog/datasets/BATS_Bottle',
  },
  {
    Sensor: 'Scatterometer',
    rank: 4,
    category: 'equipment',
    subcategory: '',
    sType: 'Device',
    Description:
      'A satellite remote sensor that measures wind speed and direction.',
    exData:
      'https://simonscmap.com/catalog/datasets/sg146_7_qcpass, https://simonscmap.com/catalog/datasets/WW_Gradients5_Stn2_L1_v2',
  },
  {
    Sensor: 'Spectral Backscattering Sensor',
    rank: 4,
    category: 'equipment',
    subcategory: '',
    sType: 'Device',
    Description:
      'Measures optical backscattering.  (See also Backscatter Sensor)',
    exData:
      'https://simonscmap.com/catalog/datasets/Tara_Oceans_Surface_Water_Measurements',
  },
  {
    Sensor: 'Temperature Sensor',
    rank: 4,
    category: 'equipment',
    subcategory: '',
    sType: 'Device',
    Description: 'Measures temperature.',
    exData:
      'https://simonscmap.com/catalog/datasets/JR19950921_amt01_meteorology, https://simonscmap.com/catalog/datasets/JR19960422_AMT02_meteorology',
  },
  {
    Sensor: 'Thermosalinograph',
    rank: 4,
    category: 'equipment',
    subcategory: '',
    sType: 'Device',
    Description:
      "A device that measures sea surface temperature and salinity from a ship's water intake.",
    exData:
      'https://simonscmap.com/catalog/datasets/PARAGON2_KM2209_PPPCPN_UW, https://simonscmap.com/catalog/datasets/TN398_uw_tsg',
  },
  {
    Sensor: 'Turbidity Sensor',
    rank: 4,
    category: 'equipment',
    subcategory: '',
    sType: 'Device',
    Description: 'Uses light to measure turbidity.',
    exData: 'https://simonscmap.com/catalog/datasets/ARGO_BGC',
  },
  {
    Sensor: 'Underway pCO2 Sensor',
    rank: 4,
    category: 'equipment',
    subcategory: '',
    sType: 'Device',
    Description:
      'Measures partial pressure of carbon dioxide while a vessel is underway.',
    exData:
      'https://simonscmap.com/catalog/datasets/Tara_Oceans_Surface_Water_Measurements',
  },
  {
    Sensor: '',
    rank: '',
    category: '',
    subcategory: '',
    sType: '',
    Description: '',
    exData: '',
  },
  {
    Sensor: 'Autoanalyzer',
    rank: 8,
    category: 'equipment - chemical analysis',
    subcategory: 'chemical analysis',
    sType: 'Device',
    Description:
      'Measures the concentration of nutrients, typically by using colorometrics. (See also Flow Autoanalyzer).',
    exData:
      'https://simonscmap.com/catalog/datasets/TN412_Gradients5_NutrientsWaterColumn, https://simonscmap.com/catalog/datasets/PARAGON1_KM2112_N_Timecourse',
  },
  {
    Sensor: 'Chemiluminescent Analyzer',
    rank: 8,
    category: 'equipment - chemical analysis',
    subcategory: 'chemical analysis',
    sType: 'Device',
    Description:
      'Measures light intensity produced by a chemical reaction to determine the concentration of a substance.',
    exData:
      'https://simonscmap.com/catalog/datasets/PARAGON2_KM2209_N_Timecourse, https://simonscmap.com/catalog/datasets/Karl_GR3_organic_and_inorganic_nutrients',
  },
  {
    Sensor: 'Colorimeter',
    rank: 8,
    category: 'equipment - chemical analysis',
    subcategory: 'chemical analysis',
    sType: 'Device',
    Description:
      'Measures the concentration of a chemical by comparing the amount of light passing through a solution to that for a pure solvent. (Alternate spelling of Colorimiter).',
    exData:
      'https://simonscmap.com/catalog/datasets/KM0704_CMORE_BULA_Bottle, https://simonscmap.com/catalog/datasets/km0704_cmore_bula_underway_samples',
  },
  {
    Sensor: 'Colorimiter',
    rank: 8,
    category: 'equipment - chemical analysis',
    subcategory: 'chemical analysis',
    sType: 'Device',
    Description:
      'Measures the concentration of a chemical by comparing the amount of light passing through a solution to that for a pure solvent. (alternate spelling of Colorimeter).',
    exData:
      'https://simonscmap.com/catalog/datasets/JR19950921_AMT01_Nutrients',
  },
  {
    Sensor: 'Electron Capture Detector',
    rank: 8,
    category: 'equipment - chemical analysis',
    subcategory: 'chemical analysis',
    sType: 'Device',
    Description:
      'A detector that uses electrons to identify and quantify compounds, often used in gas chromatography.',
    exData: 'https://simonscmap.com/catalog/datasets/KOK1606_Gradients1_Gases',
  },
  {
    Sensor: 'Elemental Analyzer',
    rank: 8,
    category: 'equipment - chemical analysis',
    subcategory: 'chemical analysis',
    sType: 'Device',
    Description:
      'Determines the elemental and sometimes isotopic composition of a sample by analyzing  combustion products in a gaseous form.',
    exData:
      'https://simonscmap.com/catalog/datasets/PARAGON1_KM2112_PC_PN_InSitu, https://simonscmap.com/catalog/datasets/PARAGON2_KM2209_PPPCPN_UW',
  },
  {
    Sensor: 'Flame Ionization Detector',
    rank: 8,
    category: 'equipment - chemical analysis',
    subcategory: 'chemical analysis',
    sType: 'Device',
    Description:
      'A detector that uses a flame to identify and quantify compounds, often used in gas chromatography.',
    exData: 'https://simonscmap.com/catalog/datasets/KOK1606_Gradients1_Gases',
  },
  {
    Sensor: 'Flow Autoanalyzer',
    rank: 8,
    category: 'equipment - chemical analysis',
    subcategory: 'chemical analysis',
    sType: 'Device',
    Description:
      'Measures the concentration of nutrients, typically by using colorimetrics. (See also Autoanalyzer).',
    exData:
      'https://simonscmap.com/catalog/datasets/GO_SHIP_P16NS_2005_2006_515Y_926R',
  },
  {
    Sensor: 'HPLC',
    rank: 8,
    category: 'equipment - chemical analysis',
    subcategory: 'chemical analysis',
    sType: 'Device',
    Description:
      'High Performance Liquid Chromatography - used to identify and quantify components in mixtures.',
    exData:
      'https://simonscmap.com/catalog/datasets/Gradients2_MGL1704_HPLC, https://simonscmap.com/catalog/datasets/hplc_pigments_914655_v1_rr1814',
  },
  {
    Sensor: 'ICP-MS',
    rank: 8,
    category: 'equipment - chemical analysis',
    subcategory: 'chemical analysis',
    sType: 'Device',
    Description:
      'Inductively coupled plasma mass spectrometry - identifies and quantifies elements and their isotopes.  Typically used to detect very low concentrations.',
    exData:
      'https://simonscmap.com/catalog/datasets/Gradients_1_Diss_Trace_Metal_Profile, https://simonscmap.com/catalog/datasets/Gradients_2_Diss_Trace_Metal_Profile',
  },
  {
    Sensor: 'Liquid Chromatograph',
    rank: 8,
    category: 'equipment - chemical analysis',
    subcategory: 'chemical analysis',
    sType: 'Device',
    Description: 'Used to identify and quantify components in mixtures.',
    exData:
      'https://simonscmap.com/catalog/datasets/dissolved_siderophore, https://simonscmap.com/catalog/datasets/KM1709_Mesoscope_B12_HILIC_Incubations',
  },
  {
    Sensor: 'Mass Spectrometer',
    rank: 8,
    category: 'equipment - chemical analysis',
    subcategory: 'chemical analysis',
    sType: 'Device',
    Description:
      'Identifies and quantifies compounds by their molecular weights.',
    exData:
      'https://simonscmap.com/catalog/datasets/Gradients5_TN412_15N13C, https://simonscmap.com/catalog/datasets/TargetedMetabolitesGradients2017_DepthProfile',
  },
  {
    Sensor: 'Spectrophotometer',
    rank: 8,
    category: 'equipment - chemical analysis',
    subcategory: 'chemical analysis',
    sType: 'Device',
    Description:
      'An instrument that measures the absorption, reflection, scattering, or emission of light by a substance.',
    exData:
      'https://simonscmap.com/catalog/datasets/MV1015_PP, https://simonscmap.com/catalog/datasets/Gradients4_TN397_PPPCPN_UW',
  },
  {
    Sensor: 'Ultraviolet Absorbance Detector',
    rank: 8,
    category: 'equipment - chemical analysis',
    subcategory: 'chemical analysis',
    sType: 'Device',
    Description:
      'Used to identify analytes in a sample, often used as detectors in HPLC.',
    exData:
      'https://simonscmap.com/catalog/datasets/Gradients3_KM1906_AA_Nutrients_UW, https://simonscmap.com/catalog/datasets/ARGO_BGC',
  },
  {
    Sensor: '',
    rank: '',
    category: '',
    subcategory: '',
    sType: '',
    Description: '',
    exData: '',
  },
  {
    Sensor: 'CPR',
    rank: 7,
    category: 'equipment - enumeration',
    subcategory: 'enumeration',
    sType: 'Device',
    Description:
      'Continuous Plankton Recorder - A plankton sampling device that is towed from a ship and takes continuous samples.',
    exData:
      'https://simonscmap.com/catalog/datasets/CPR_Zooplankton, https://simonscmap.com/catalog/datasets/CPR_Phytoplankton',
  },
  {
    Sensor: 'Epifluorescent Microscope',
    rank: 7,
    category: 'equipment - enumeration',
    subcategory: 'enumeration',
    sType: 'Device',
    Description:
      'A type of microscope used to see objects that fluoresce at certain wavelengths, either due to their pigmentation or due to treatment with a fluorescent dye.',
    exData:
      'https://simonscmap.com/catalog/datasets/HOELegacy2A_KM1513_DiazotrophAbundance, https://simonscmap.com/catalog/datasets/Gradients1_KOK1606_DiazotrophAbundance',
  },
  {
    Sensor: 'Flow Cytobot',
    rank: 7,
    category: 'equipment - enumeration',
    subcategory: 'enumeration',
    sType: 'Device',
    Description:
      'An imaging flow cytometer that measures particle fluorescence, light-scattering and captures images of particles.',
    exData:
      'https://simonscmap.com/catalog/datasets/G5_IFCB_Underway_VDn, https://simonscmap.com/catalog/datasets/G3_IFCB_Underway_PSDn',
  },
  {
    Sensor: 'Flow Cytometer',
    rank: 7,
    category: 'equipment - enumeration',
    subcategory: 'enumeration',
    sType: 'Device',
    Description:
      'An instrument that analyzes particles using lasers to measure the light scattering or fluorescent properties of each particle.',
    exData:
      'https://simonscmap.com/catalog/datasets/Influx_Underway_TN428_2024v1_0, https://simonscmap.com/catalog/datasets/Particle_Abundances',
  },
  {
    Sensor: 'Flow Cytometer and Microscope',
    rank: 7,
    category: 'equipment - enumeration',
    subcategory: 'enumeration',
    sType: 'Device',
    Description:
      'Both a microscope and a flow cytometer (an instrument that analyzes particles using lasers to measure the light scattering or fluorescent properties of each particle) were used.',
    exData: 'https://simonscmap.com/catalog/datasets/Flombaum',
  },
  {
    Sensor: 'FlowCam',
    rank: 7,
    category: 'equipment - enumeration',
    subcategory: 'enumeration',
    sType: 'Device',
    Description:
      'An instrument used for the imaging and analysis of particles in a fluid medium.  Typically used in oceanography to enumerate, measure, and classify plankton.',
    exData:
      'https://simonscmap.com/catalog/datasets/RR1604_flow_cytometry_mass_spec',
  },
  {
    Sensor: 'LISST',
    rank: 7,
    category: 'equipment - enumeration',
    subcategory: 'enumeration',
    sType: 'Device',
    Description:
      'An instrument that uses a laser to measure the size distribution and concentration of suspended particles.',
    exData:
      'https://simonscmap.com/catalog/datasets/PARAGON2_KM2209_Optics_LISST_ACS_ECO, https://simonscmap.com/catalog/datasets/Gradients5_TN412_LISST_DEEP_Profiles',
  },
  {
    Sensor: 'SeaFlow',
    rank: 7,
    category: 'equipment - enumeration',
    subcategory: 'enumeration',
    sType: 'Device',
    Description:
      'A shipboard underway flow cytometer that provides continuous multi-parameter particle measurements of light scatter and fluorescence.',
    exData: 'https://simonscmap.com/catalog/datasets/all_SeaFlow_cruises_v1_5',
  },
  {
    Sensor: '',
    rank: '',
    category: '',
    subcategory: '',
    sType: '',
    Description: '',
    exData: '',
  },
  {
    Sensor: 'GPS',
    rank: 1,
    category: 'equipment - navigation',
    subcategory: 'navigation',
    sType: 'Device',
    Description:
      'Global Positioning System - A satellite based navigation system that is used to determine location.',
    exData:
      'https://simonscmap.com/catalog/datasets/JR19960422_AMT02_bathymetry, https://simonscmap.com/catalog/datasets/JR19950921_amt01_bathymetry',
  },
  {
    Sensor: 'Gyrocompass',
    rank: 1,
    category: 'equipment - navigation',
    subcategory: 'navigation',
    sType: 'Device',
    Description: 'A non-magnetic compass.',
    exData:
      'https://simonscmap.com/catalog/datasets/JR19960422_AMT02_bathymetry, https://simonscmap.com/catalog/datasets/JR19950921_amt01_bathymetry',
  },
  {
    Sensor: '',
    rank: '',
    category: '',
    subcategory: '',
    sType: '',
    Description: '',
    exData: '',
  },
  {
    Sensor: 'Bottle',
    rank: 6,
    category: 'equipment - sampling',
    subcategory: 'sampling',
    sType: 'Device',
    Description:
      'Used to collect water samples from discrete depths.  Typically deployed on a rosette along with a CTD.',
    exData:
      'https://simonscmap.com/catalog/datasets/HOT_Bottle_ALOHA, https://simonscmap.com/catalog/datasets/Tara_nutrients_flow_cytometry',
  },
  {
    Sensor: 'High Volume Peristaltic Pump',
    rank: 6,
    category: 'equipment - sampling',
    subcategory: 'sampling',
    sType: 'Device',
    Description: 'A roller pump that pumps a high volume of fluid.',
    exData: '',
  },
  {
    Sensor: 'Sediment Trap',
    rank: 6,
    category: 'equipment - sampling',
    subcategory: 'sampling',
    sType: 'Device',
    Description:
      'Used to collect the downward flux of particulate matter in the ocean.',
    exData:
      'https://simonscmap.com/catalog/datasets/HOT_ParticleFlux_v2022, https://simonscmap.com/catalog/datasets/BATS_Sediment_Trap_Flux',
  },
  {
    Sensor: 'Zooplankton Net',
    rank: 6,
    category: 'equipment - sampling',
    subcategory: 'sampling',
    sType: 'Device',
    Description:
      'A fine messhed net used to collect zooplankton, typically deployed from a ship.',
    exData:
      'https://simonscmap.com/catalog/datasets/NOAA_COPEPOD, https://simonscmap.com/catalog/datasets/BATS_Zooplankton_Biomass',
  },
  {
    Sensor: '',
    rank: '',
    category: '',
    subcategory: '',
    sType: '',
    Description: '',
    exData: '',
  },
  {
    Sensor: 'Blend',
    rank: 12,
    category: 'Observation-Constrained Model',
    subcategory: '',
    sType: 'Method',
    Description: 'Observation-Constrained Model',
    exData:
      'https://simonscmap.com/catalog/datasets/Mercator_Pisces_Biogeochemistry_Daily_Forecast_Co2, https://simonscmap.com/catalog/datasets/SOCATv2022',
  },
  {
    Sensor: 'Numerical Model',
    rank: 12,
    category: 'Theory',
    subcategory: '',
    sType: 'Method',
    Description:
      'A numerical simulation that does not incorporate observation.',
    exData: '',
  },
  {
    Sensor: 'ddPCR',
    rank: 9,
    category: 'PCR',
    subcategory: '',
    sType: 'Method',
    Description:
      'Droplet Digital Polymerase Chain Reaction - a lab technique that quantifies the concentration of specific segments of DNA or RNA in a sample by partitioning a sample into thousands of droplets and detecting the presence of those segments of DNA or RNA in each droplet.',
    exData:
      'https://simonscmap.com/catalog/datasets/HOT_AmoA_gene_abundances, https://simonscmap.com/catalog/datasets/UCYN_A1_nifH_copies_L_1',
  },
  {
    Sensor: 'PCR',
    rank: 9,
    category: 'PCR',
    subcategory: '',
    sType: 'Method',
    Description:
      'Polymerase Chain Reaction - a lab technique used to make many copies of specific segments of DNA',
    exData: '',
  },
  {
    Sensor: 'qPCR',
    rank: 9,
    category: 'PCR',
    subcategory: '',
    sType: 'Method',
    Description:
      'Quantitative polymerase chain reaction - a lab technique used to detect and quantify specific segments of DNA or RNA in a sample.',
    exData:
      'https://simonscmap.com/catalog/datasets/MGL1704_Gradients2_Diazotroph, https://simonscmap.com/catalog/datasets/HOT_nifH_gene_abundances',
  },
  {
    Sensor: 'Potentiometric Titration',
    rank: 10,
    category: 'Titration',
    subcategory: '',
    sType: 'Method',
    Description:
      'A method that uses the potential between two electrodes to measure the concentration of a solution.',
    exData:
      'https://simonscmap.com/catalog/datasets/MV1015_cmore_bottle, https://simonscmap.com/catalog/datasets/KM0704_CMORE_BULA_Bottle',
  },
  {
    Sensor: 'Titration',
    rank: 10,
    category: 'Titration',
    subcategory: '',
    sType: 'Method',
    Description:
      'A lab method used to determine the concentration of a substance.',
    exData:
      'https://simonscmap.com/catalog/datasets/KM1906_Gradients3, https://simonscmap.com/catalog/datasets/HOT_LAVA',
  },
  {
    Sensor: 'Winkler Titration',
    rank: 10,
    category: 'Titration',
    subcategory: '',
    sType: 'Method',
    Description:
      'A titration technique used to determine the concentration of dissolved oxygen in water samples.',
    exData:
      'https://simonscmap.com/catalog/datasets/MV1015_cmore_bottle, https://simonscmap.com/catalog/datasets/KM0704_CMORE_BULA_Bottle',
  },
  {
    Sensor: 'Fluorogenic Substrate',
    rank: 11,
    category: 'Generic',
    subcategory: '',
    sType: 'Method',
    Description:
      'A substrate used in fluorogenic assays that fluoresces when acted on by an enzyme.',
    exData: 'https://simonscmap.com/catalog/datasets/APA_MesoSCOPE_KM1709',
  },
  {
    Sensor: 'High Temperature Combustion',
    rank: 11,
    category: 'Generic',
    subcategory: '',
    sType: 'Method',
    Description:
      'A method used to measure total organic carbon in seawater samples.',
    exData:
      'https://simonscmap.com/catalog/datasets/PARAGON1_KM2112_TOC_InSitu, https://simonscmap.com/catalog/datasets/PARAGON1_KM2112_TOC_Timecourse',
  },
  {
    Sensor: 'Incubation',
    rank: 11,
    category: 'Generic',
    subcategory: '',
    sType: 'Method',
    Description:
      'A method where a sample is incubated under controlled conditions.',
    exData:
      'https://simonscmap.com/catalog/datasets/Gradients1_KOK1606_14C_NPP, https://simonscmap.com/catalog/datasets/Gradients1_KOK1606_15N13C',
  },
  {
    Sensor: 'Manual Inspection',
    rank: 11,
    category: 'Generic',
    subcategory: '',
    sType: 'Method',
    Description:
      'Inspection of a sample by a person using sight, touch, or smell.',
    exData:
      'https://simonscmap.com/catalog/datasets/GO_SHIP_P16NS_2005_2006_515Y_926R',
  },
  {
    Sensor: 'Optical',
    rank: 11,
    category: 'Generic',
    subcategory: '',
    sType: 'Method',
    Description:
      'Generic sensor term used in CMAP to refer to spectrophotometers, transmissometers, radiometers, and particle sensors.',
    exData:
      'https://simonscmap.com/catalog/datasets/PARAGON2_KM2209_Optics_LISST_ACS_ECO, https://simonscmap.com/catalog/datasets/PARAGON2_KM2209_SurfacePAR_LICOR',
  },
  {
    Sensor: '',
    rank: '',
    category: '',
    subcategory: '',
    sType: '',
    Description: '',
    exData: '',
  },
  {
    Sensor: 'Uncategorized',
    rank: 13,
    category: 'uncategorized',
    subcategory: '',
    sType: 'Uncategorized',
    Description:
      "Used for variables that don't involve a sensor such as station number, flag, cast number.",
    exData:
      'https://simonscmap.com/catalog/datasets/Gradients5_TN412_FluorometricChlorophyll_CTD, https://simonscmap.com/catalog/datasets/TN397_Gradients4_NutrientsAndParticulates',
  },
];
